module.exports = __webpack_public_path__ + "img/checkicon.d0e92b8f.svg";